import { FETCH_QUESTION_SET } from '../constants/actionTypes'

export default (state = {}, action) => {
    switch (action.type) {
        case FETCH_QUESTION_SET:
            return {
                ...state,
                questionset: Array.isArray(action.payload) ? action.payload : [],
                isFetching: false,
            }
        default:
            return state
    }
}
